import {
  selectImageryCapabilities,
  setAccessPermissions,
  setInstruments,
  setPublishingStages,
  setSR,
} from '@explorer/actions/search-filters';

export const buildSearchFilterActions = storedState => {
  const actions = [];
  if (storedState.searchFilters) {
    const filters = storedState.searchFilters;
    if (filters.sr !== undefined) {
      actions.push(setSR(filters.sr));
    }
    if (filters.instruments) {
      const selectedInstruments = {};
      filters.instruments.forEach(item => {
        selectedInstruments[item.name] = item.on;
      });
      actions.push(setInstruments(selectedInstruments));
    }
    if (filters.publishingStages) {
      const selectedStages = {};
      filters.publishingStages.forEach(item => {
        selectedStages[item.name] = item.on;
      });
      actions.push(setPublishingStages(selectedStages));
    }
    if (filters.selectedImageryCapabilities) {
      actions.push(
        selectImageryCapabilities(filters.selectedImageryCapabilities)
      );
    }
    if (filters.accessPermissions !== undefined) {
      actions.push(setAccessPermissions(filters.accessPermissions));
    }
  }
  return actions;
};
